import { Ventilator } from "../class-definitions/ventilator";
import { apolloClient } from "@/main";
import { INSERT_VENTILATOR } from "../graphql/CreateNewVentilator";
import { UPDATE_VENTILATOR } from "../graphql/UpdateVentilator";
import { DELETE_VENTILATOR } from "../graphql/DeleteVentilator";
import store from "@/store/store";

/**
 * @type {User}
 */
let user = store.state.AppActiveUser;

/**
 * - Converts the data returned from Hasura to a proper Note instance.
 * @param {object} subscription - The object holding the data of the Note.
 * @returns {Ventilator} Note - The instantiated Note.
 */
export const filterVentilatorSubscription = subscription => {
  let ventilator = subscription.data.ventilator_by_pk;
  return new Ventilator({
    id: ventilator.id,
    serialNumber: ventilator.serialNumber,
    manufacturer: ventilator.manufacturer,
    model: ventilator.model,
    type: ventilator.type,
    status: ventilator.status,
    condition: ventilator.condition,
    location: ventilator.ventilator_location,
    user: ventilator.ventilator_user,
    team: ventilator.ventilator_team
  });
};

/**
 * - Creates a new Note record in the DB.
 * @param {Ventilator} ventilator
 * @returns {Promise<string>} ventilator.id
 */
export const createNewVentilatorPromise = ventilator => {
  return new Promise((resolve, reject) => {
    user
      .checkAuthExpiration()
      .then(() => {
        apolloClient
          .mutate({
            mutation: INSERT_VENTILATOR,
            variables: {
              serialNumber: ventilator.serialNumber,
              manufacturer: ventilator.manufacturer,
              model: ventilator.model,
              type: ventilator.type,
              condition: ventilator.condition,
              location_id: ventilator.location.id,
              status: ventilator.status,
              user_id: ventilator.user.id,
              team_id: ventilator.team.id
            }
          })
          .then(updatedRecord => {
            resolve(updatedRecord);
          })
          .catch(error => {
            reject(error);
          });
      })
      .catch(error => {
        reject(error);
      });
  });
};

/**
 * @param {Ventilator} ventilator
 * @returns {Promise<string>} ventilator.id
 */
export const updateVentilatorPromise = ventilator => {
  return new Promise((resolve, reject) => {
    apolloClient
      .mutate({
        mutation: UPDATE_VENTILATOR,
        variables: {
          id: ventilator.id,
          serialNumber: ventilator.serialNumber,
          condition: ventilator.condition,
          location_id: ventilator.location.id,
          manufacturer: ventilator.manufacturer,
          model: ventilator.model,
          status: ventilator.status,
          type: ventilator.type,
          user_id: ventilator.user.id
        }
      })
      .then(updatedRecord => {
        resolve(updatedRecord);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/**
 * - takes a ventilator relationship from a hasura entity and returns an instantiated HospitalReport
 * @param {object} ventilator
 * @returns {Ventilator}
 */
export const filterVentilatorRelationship = ventilator => {
  return ventilator
    ? new Ventilator({
        id: ventilator.id,
        serialNumber: ventilator.serialNumber,
        manufacturer: ventilator.manufacturer,
        model: ventilator.model,
        type: ventilator.type,
        status: ventilator.status,
        condition: ventilator.condition,
        location: ventilator.ventilator_location,
        user: ventilator.ventilator_user
      })
    : {};
};

/**
 * @param {Ventilator} ventilator
 * @returns {Promise<string>} ventilator.id
 */
export const deleteVentilatorPromise = ventilator => {
  return new Promise((resolve, reject) => {
    apolloClient
      .mutate({
        mutation: DELETE_VENTILATOR,
        variables: {
          id: ventilator.id
        }
      })
      .then(updatedRecord => {
        resolve(updatedRecord);
      })
      .catch(error => {
        reject(error);
      });
  });
};
